<template>
    <div class="MAM_editInfo">
        <el-dialog :visible="infoIsShow" @close="handleClose" :close-on-click-modal="false" >
            <el-card class="box-card" shadow="hover">
                <el-form :inline="true" :model="infoForm" class="demo-form-inline">
                    <el-form-item>
                        <span class="demonstration">活动时间延长至</span>
                        <br />
                        <el-date-picker
                                v-model="infoForm.end_time"
                                type="date"
                                end-placeholder="活动结束时间"
                                value-format="yyyy-MM-dd HH:mm:ss"
                        ></el-date-picker>
                    </el-form-item>
                    <br />
                    <el-form-item>
                        <el-button
                                type="primary"
                                @click="handleSubmit(infoForm)"
                                :loading="submitLoading"
                        >修改</el-button>
                    </el-form-item>
                </el-form>
            </el-card>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "MAM_editInfo",
        props: {
            idsArray:{
                type:Array,
                default: function () {
                    return  [];
                }
            },
            useridArray:{
                type:Array,
                default: function () {
                    return  [];
                }
            },
            infoIsShow: {
                type: Boolean,
                default: false
            },
            detail: {
                type: Object
            },
            isShowRate: {
                type: Boolean,
                default: false
            },
            publickData: {
                type: Object
            },
            canSet: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                transctionInfoTable: [], //表格
                cashList: [],//押金模板
                flowList: [],//押金模板
                infoForm: {
                    ids: this.idsArray, //id
                },
                baseOrRise: 'base', //基础费率or涨价后费率
                baseActiveName: '1', //基础费率 - Tab默认选中
                baseTabContent: [], //基础费率 -tab内容
                baseOldData: [], //基础费率 - 旧数据(对比使用)
                riseActiveName: '1',//涨价后费率 - Tab默认选中
                riseTabContent: [], //涨价后费率 -tab内容
                riseOldData: [], //涨价后费率 - 旧数据(对比使用)
                isEdit: 0, //是否可以编辑 1是 0否
                btnLoading: false,
                level: sessionStorage.getItem('level'),
                viewData: {},
                loading: true,
                submitLoading: false,
                end_time: '',
            }
        },
        mounted() {
            var arr = [];
        },
        methods: {
            handleClose() {
                this.$emit('infoClose')  //关闭
            },
            handleSubmit(field) { //提交
                this.submitLoading = true;
                let that = this;
                this.$api.post('activity_merchant_status/get_activity_merchant_end_time_edit', this.infoForm, res => {
                    if (res.code == 0) {
                        //console.log(res, 'res');
                        this.$message({
                            type: 'success',
                            duration: 1500,
                            message: res.msg,
                            onClose() {
                                that.handleClose(1);
                            }
                        });
                    }else{
                        this.$message.error(res.msg);
                    }
                    this.submitLoading = false;
                })
            },
        }
    };
</script>
<style scoped lang="scss">
    .MAM_editInfo {
        font-size: 12px;
        .el-input__inner,
        .tips {
            font-size: 12px;
        }

        .el-form-item {
            margin-bottom: 5px;
        }

        ::v-deep .el-form-item__label {
            padding: 0;
            font-size: 12px;
        }
        .titleTip {
            padding: 10px 10px;
            background-color: #ecf8ff;
            border-radius: 4px;
            font-size: 13px;
            font-weight: 700;
            border-left: 5px solid #50bfff;
            margin: 10px 0;
        }
        .title p {
            font-size: 12px;
            :first-child {
                font-weight: 700;
            }
        }
    }
    .setUserRate {
        ::v-deep .el-form-item__label {
            font-size: 12px;
            font-weight: 700;
        }
        ::v-deep .el-input__inner {
            width: 150px;
        }
        ::v-deep .el-dialog {
            height: 80%;
            .el-dialog__body {
                height: 82%;
                overflow: auto;
            }
        }
        .type_title {
            margin: 10px 0;
            font-size: 13px;
            font-weight: 700;
            border-left: 5px solid #40b8ff;
            padding: 0 0 0 10px;
        }
    }
</style>